module.exports = __webpack_public_path__ + "static/img/10-box.0996d5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10-box.png
// module id = xStk
// module chunks = 0